import { useState } from "react";
import { login } from "../services/authService";
import ForgotPasswordForm from "../components/ForgotPasswordForm";
import { useNavigate } from "react-router-dom";
import { forgotPassword } from "../services/authService";
import Layout from "../pages/Layout";
import { Helmet } from "react-helmet";


const ForgotPassword = () => {
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");
  const navigate = useNavigate();

  const handleForgotPassword = async (formData) => {
    setLoading(true);
    setMessage("");

    const result = await forgotPassword(formData);

    if (result.success) {
        setMessage(result.message);
    } else {
      setMessage(result.message);
    }

    setLoading(false);
  };

  return (
    <div>
      <Helmet>
        <title>Forgot Password - Factbazaar</title>
        <meta name="description" content="Reset your password securely at Factbazaar. Enter your registered email to receive a reset link." />
  <meta name="keywords" content="Forgot Password, Reset Password, Factbazaar Account Recovery, Secure Login" />
  <meta name="author" content="Factbazaar Team" />
      </Helmet>
      <Layout>
      <ForgotPasswordForm onSubmit={handleForgotPassword} loading={loading} />
  
      {message && (
        <div className="row justify-content-center">
          <div className="col-md-4">
            <div className="alert alert-danger mt-3 text-center" role="alert">
              {message}
            </div>
          </div>
        </div>
      )}
      </Layout>
    </div>
  );
  
};

export default ForgotPassword;
